import { Link } from 'react-router-dom';
import { buildFamilies, shopTierForSlug, SHOP_TIER_LABEL } from '@evi/store-kit';
import { useCatalog } from '@/hooks/useCatalog';
import { FamilyCard } from '@/components/FamilyCard';
import styles from './CategoryPage.module.css';

/** A shop category grid: every product family in one tier. Slug -> tier via
 *  the shared SHOP_CATEGORIES map; families come from the same engine the
 *  driver store uses. */
export function CategoryPage({ slug }: { slug: string }) {
  const { data: catalog, isLoading, isError } = useCatalog();
  const tier = shopTierForSlug(slug);
  const families = catalog && tier ? buildFamilies(catalog).filter((f) => f.tier === tier) : [];
  const label = tier ? SHOP_TIER_LABEL[tier] : slug;

  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <h1 className={styles.title}>{label}</h1>
        {tier === 'dc' && (
          <p className={styles.sub}>
            Every DC charger ships commissioning-inclusive — the price includes
            pre-commissioning to the network.
          </p>
        )}
        {/* Commercial AC buyers: pointer to the incentives finder. Was a
            bare text link; promoted to a full button (Warren) so it is
            findable at a glance. */}
        {tier === 'commercial_ac' && (
          <Link to="/incentives" className={`eviBtn eviBtnPrimary ${styles.incentivesLink}`}>
            Check incentives in your area &rarr;
          </Link>
        )}
      </header>

      {isLoading && <p className={styles.state}>Loading the catalog…</p>}
      {isError && <p className={styles.state}>Could not load the catalog. Please try again.</p>}
      {!isLoading && !isError && families.length === 0 && (
        <p className={styles.state}>Nothing here yet.</p>
      )}

      <div className={styles.grid}>
        {families.map((f) => (
          <FamilyCard key={f.key} family={f} />
        ))}
      </div>
    </div>
  );
}
